import { useGetIdentity, useTranslate } from "ra-core";
import { ListBase } from "ra-core";
import { SelectField } from "@/components/admin/select-field";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

import { Dashboard } from "../dashboard/Dashboard";
import { MobileDashboard } from "../dashboard/MobileDashboard";
import { SimpleList } from "../simple-list/SimpleList";
import { IthnkPage } from "./IthnkPage";
import { InvoiceAmountField, InvoiceStatusField } from "./invoices";
import { deliveryPhaseChoices, overdueFilter } from "./ithnkUtils";

/** Delivery users get their upcoming deliveries and the overdue invoices instead of the sales widgets */
const DeliveryDashboard = ({ salesId }: { salesId: string | number }) => {
  const translate = useTranslate();
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-1">
      <Card>
        <CardHeader>
          <CardTitle>{translate("resources.deliveries.upcoming")}</CardTitle>
        </CardHeader>
        <CardContent>
          <ListBase
            resource="deliveries"
            filter={{
              assigned_sales_id: salesId,
              "phase@in": "(not_started,in_progress)",
            }}
            sort={{ field: "due_date", order: "ASC" }}
            perPage={20}
            disableSyncWithLocation
            storeKey={false}
          >
            <SimpleList
              resource="deliveries"
              rowClick="show"
              primaryText={(record) => record.title}
              secondaryText={
                <SelectField source="phase" choices={deliveryPhaseChoices} />
              }
              tertiaryText={(record) => record.due_date}
            />
          </ListBase>
        </CardContent>
      </Card>
      <Card>
        <CardHeader>
          <CardTitle>{translate("resources.invoices.overdue_list")}</CardTitle>
        </CardHeader>
        <CardContent>
          <ListBase
            resource="invoices"
            filter={overdueFilter()}
            sort={{ field: "due_date", order: "ASC" }}
            perPage={20}
            disableSyncWithLocation
            storeKey={false}
          >
            <SimpleList
              resource="invoices"
              rowClick="show"
              primaryText={(record) => record.number}
              secondaryText={<InvoiceStatusField />}
              tertiaryText={<InvoiceAmountField />}
            />
          </ListBase>
        </CardContent>
      </Card>
    </div>
  );
};

export const DesktopRoleDashboard = () => {
  const { identity } = useGetIdentity();
  if (!identity) return null;
  return identity.role === "delivery" ? (
    <DeliveryDashboard salesId={identity.id} />
  ) : (
    <Dashboard />
  );
};

export const MobileRoleDashboard = () => {
  const { identity } = useGetIdentity();
  if (!identity) return null;
  return identity.role === "delivery" ? (
    <IthnkPage title="ra.page.dashboard">
      <DeliveryDashboard salesId={identity.id} />
    </IthnkPage>
  ) : (
    <MobileDashboard />
  );
};
